/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum OpsRecipientConfirmationState {
    ConfirmedDoubleOptIn = 'CONFIRMED_DOUBLE_OPT_IN',
    ConfirmedByAccountantFinalise = 'CONFIRMED_BY_ACCOUNTANT_FINALISE',
    ConfirmedOriginUnknown = 'CONFIRMED_ORIGIN_UNKNOWN',
    PendingNotSent = 'PENDING_NOT_SENT',
    PendingAwaitingConfirmation = 'PENDING_AWAITING_CONFIRMATION',
    PendingLinkExpired = 'PENDING_LINK_EXPIRED',
    Expired = 'EXPIRED',
    Rejected = 'REJECTED'
}



